/**
 * Enum for notification types.
 *
 * File: \src\components\messages\handler\UserNotificationType.ts
 * Created Date: Tuesday, May 28th 2019, 08:22:41
 * Author: Sascha Herrmann
 * -----
 * Last Modified: March 4th 2021, 13:49:30
 * Modified By: Sascha Herrmann
 * -----
 * Copyright (c) 2017-2019 Liebherr-Hausgeräte GmbH
 */

/**
 * Simple enum to handle different types of messages.
 *
 * @export
 * @enum {number}
 */
export enum UserNotificationType {
  'SNACK',
  'WARNING',
  'ERROR',
  'INTERNAL_ERROR'
}
